import React from "react";
import { useAuth } from "../AuthContext";

export default function Sidebar({ setActive, active }) {
  const { role } = useAuth();
  const isSuperadmin = role === "superadmin";

  return (
    <div className="admin-sidebar">
      <h2>Admin</h2>

      <ul>
        <li
          className={active === "businesses" ? "active" : ""}
          onClick={() => setActive("businesses")}
        >
          Businesses
        </li>

        <li
          className={active === "analytics" ? "active" : ""}
          onClick={() => setActive("analytics")}
        >
          Analytics
        </li>

        {isSuperadmin && (
          <li
            className={active === "categories" ? "active" : ""}
            onClick={() => setActive("categories")}
          >
            Categories
          </li>
        )}
      </ul>
    </div>
  );
}